export enum FormActions {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  EDIT_APPROVED_FORM = 'EDIT_APPROVED_FORM',
  DOWNLOAD_PDF = 'DOWNLOAD_PDF',
  RESET_PASSWORD = 'RESET_PASSWORD',
  PRINT_BLANK = 'PRINT_BLANK',
  MANUAL_UPLOAD = 'MANUAL_UPLOAD',
  MANUAL_REMOVE = 'MANUAL_REMOVE',
  EXPORT_EVENTS = 'EXPORT_EVENTS',
  EXPORT_EXCEL = 'EXPORT_EXCEL',
  DETAILED_REPORT_EXPORT = 'DETAILED_REPORT_EXPORT',
  FORM_SEARCH_EXPORT_EXCEL = 'FORM_SEARCH_EXPORT_EXCEL',
  REMOVE = 'REMOVE',
  APPROVE_SELECTED = 'APPROVE_SELECTED',
  APPROVE_ALL = 'APPROVE_ALL',
  MANUAL_UPDATE_IPT = 'MANUAL_UPDATE_IPT',
  CHANGE_USER_DETAILS = 'CHANGE_USERD_DETAILS',
  UNLOCK_USER = 'UNLOCK_USER',
  UPLOAD_MANAGER_PRIVILEGES = 'UPLOAD_MANAGER_PRIVILEGES',
  UPLOAD_MANAGER_PRIVILEGES_UNIT = 'UPLOAD_MANAGER_PRIVILEGES_UNIT',
}
